<template>
  <div class="seller-detail-page">

    <div class="sellerinfo">
      <el-row>
        <el-col :span="16" :class="'shopnameinfo ' + logoimg">
          <h1 class="shopnametxt">{{ details.ShopName }} <a style="color:#666;" :href="details.ShopUrl" target="_blank"><i class="el-icon-link"></i></a></h1>
          <h2 class="shopidtxt">ID：{{ routerparams.ShopId }}</h2>
        </el-col>
        <el-col :span="8" style="height:60px;">
          <span style="float:right; font-size:14px;">{{$t("charts.latestupdate")}}：{{ update }}</span><br/>
          <el-button :loading="downloading" class="downloadpdfbtn" style="float:right; margin-right:0; margin-top:10px;" type="danger" @click="downloaddata()" size="small">{{ $t('jgjk.s74') }}</el-button>
        </el-col>
      </el-row>
    </div>
    
    <div class="sellerbaseinfobox">
      <el-descriptions :column="3" border size="small">
          <el-descriptions-item :label="$t('Seller.t11')">
            <el-rate
              v-model="details.shopLevel"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}">
            </el-rate>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t16')">
            <el-rate
              class="platformlevelcolors"
              v-model="details.channelLevel"
              disabled
              show-score
              :colors="['#4169E1', '#4169E1', '#4169E1']"
              text-color="#4169E1"
              score-template="{value}">
            </el-rate>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t17')">{{ details.ShopCredit }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t18')">{{ details.tsCount }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t19')">{{ details.cgCount }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t20')">{{ details.tsTime }}</el-descriptions-item>

          <el-descriptions-item :label="$t('dsfx.t23')">{{ details.isAuth }}</el-descriptions-item>
          <el-descriptions-item :label="$t('jgjk.s211')">{{ details.shopLab }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t21')">{{ details.isYjdf }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t22')">{{ details.fansNum }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t23')">{{ details.weiXin }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t24')">{{ details.weibo }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t25')">{{ details.sellerName }}</el-descriptions-item>
          <el-descriptions-item :label="$t('Seller.t26')" span="2">{{ details.mobile }}</el-descriptions-item>

          <el-descriptions-item :label="$t('Seller.t27')" span="3">{{ details.ShopAddress }}</el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="sellertablebox">
      <div class="report-table-tabs">
        <ul>
          <li :class="{ activetabsbtn: selectedTab === 1}"><button @click="onSelectTab(1)" type="button">{{ $t('Seller.t15') }}({{ totalproducts }})</button></li>
          <li :class="{ activetabsbtn: selectedTab === 2}" v-if="totalsellers > 0"><button @click="onSelectTab(2)" type="button">{{ $t('Seller.t10') }}({{ totalsellers }})</button></li>
        </ul>
      </div>
      <div class="sellertable">
        <SellerProductTable v-if="selectedTab === 1"/>
        <SellerRelateTable v-if="selectedTab === 2"/>
      </div>
    </div>

  </div>
</template>

<script>
import SellerProductTable from '@/components/Seller/SellerProductTable.vue'
import SellerRelateTable from '@/components/Seller/SellerRelateTable.vue'
export default {
  components:{
    SellerProductTable,
    SellerRelateTable
  },
  data(){
    return{
      downloading: false,
      routerparams: {
        Id: this.$route.params.Id,
        ShopId: this.$route.params.Sid,
      },
      details: {},
      ratevalue: 3.7,
      baseinfo: {
        channelrate: 3.5,
        bpsrate: 3.9
      },
      tableloading: false,
      selectedTab: 1,
      totalproducts: 0,
      totalsellers: 0,
      logoimg: '',
      update: '',
      shopinfo: {
        taskname: '',
        taskId: '',
        shopname: '',
        shopid: this.$route.params.Sid,
        language: window.localStorage.getItem('localeLanguage')
      }
    }
  },

  computed: {
    showtotalproducts(){
      return this.$store.state.totalproducts
    },
    // showtotalsellers(){
    //   return this.$store.state.totalsellers
    // }
  },

  watch:{
    showtotalproducts: function(){
      this.totalproducts = this.$store.state.totalproducts
    },
    // showtotalsellers: function(){
    //   this.totalsellers = this.$store.state.totalsellers
    // }
  },

  mounted(){
    this.getTaskName()
    this.getDetails()
    this.getCount()
  },

  methods: {

    /**
     * 获取项目名称
     */
    getTaskName: function(){
      let brandobj = JSON.parse(window.localStorage.getItem('price')).val
      let _filter = brandobj.filter(arr => {
        return arr.subid/1 === this.$route.params.Id/1
      })
      let objname = _filter[0].name
      let objtaskid = _filter[0].subid
      let brandnamearr = objname.split('/')
      let brandname = brandnamearr[0] + '_' + brandnamearr[1]
      this.shopinfo.taskname = brandname
      this.shopinfo.taskId = objtaskid
    },

    /**
     * Tabs切换
     */
    onSelectTab: function(tid){
      let that = this
      that.selectedTab = tid
    },

    /**
     * 店铺详情
     */
    getDetails: function(){
      let that = this
      let url = that.API_URL + '/v3/price/shop/detailInfo?shopid=' + this.$route.params.Sid + '&subid=' + this.$route.params.Id;
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        success: function(rex) {
          console.log('getDetails', rex)
          let shopdetail = rex.results[0][0]
          that.logoimg = that.setChannel(shopdetail.channelName).src
          shopdetail.isYjdf = shopdetail.isYjdf/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
          shopdetail.isAuth = shopdetail.isAuth/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
          shopdetail.shopLab = shopdetail.shopLab/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
          shopdetail.shopLevel = shopdetail.shopLevel === '' || shopdetail.shopLevel === null ? 5 : shopdetail.shopLevel*1
          shopdetail.channelLevel = shopdetail.channelLevel === '' || shopdetail.channelLevel === null ? 5 : shopdetail.channelLevel*1
          shopdetail.weiXin = shopdetail.weiXin == '无数据' ? '' : shopdetail.weiXin
          shopdetail.weibo = shopdetail.weibo == '无数据' ? '' : shopdetail.weibo
          shopdetail.mobile = shopdetail.mobile == '无数据' ? '' : shopdetail.mobile
          shopdetail.tsTime = shopdetail.tsTime == null ? '' : that.$moment(shopdetail.tsTime).utc().format('YYYY-MM-DD HH:mm')
          that.details = shopdetail
          that.shopinfo.shopname = shopdetail.ShopName
          that.update = that.$moment(rex.results[1][0].createTime).local().format('YYYY-MM-DD HH:mm')
        },
        error: function(response) {
          console.log('getDetails', response)
        }
      })

    },

    getCount: function () {
      let that = this
      let url = this.API_URL + '/v3/price/shop/getCount?shopId=' + this.$route.params.Sid + '&subid=' + this.$route.params.Id;
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('tableviewModelChange',rex)
          that.totalsellers = rex.results.count
					// that.$store.state.totalsellers = rex.results[0][0].Count
        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    /**
     * 生成PDF
     */
    downloaddata: function(){
      let that = this
      that.downloading = true
      let url = this.API_URL + '/v3/price/shop/htmltopdf?taskName='
                + that.shopinfo.taskname
                + '&taskId='
                + that.shopinfo.taskId
                + '&shopName='
                + that.shopinfo.shopname
                + '&shopId='
                + that.shopinfo.shopid
                + '&language='
                + that.shopinfo.language
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('downloaddata',rex)
          that.downloading = false
          that.getPDF()
        },
        error: function(response) {
          console.log(response)
        }
      })

    },

    /**
     * 下载PDF
     */
    getPDF: function(){
      let that = this
      let url = this.API_URL + '/v3/price/shop/downloadpdf?taskName='
                + that.shopinfo.taskname
                + '&taskId='
                + that.shopinfo.taskId
                + '&shopName='
                + that.shopinfo.shopname
                + '&shopId='
                + that.shopinfo.shopid
                + '&language='
                + that.shopinfo.language
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getPDF',rex)
          that.downFile(rex.results.url)
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 下载
     */
    downFile (url) {
      let a = document.createElement('a')
      // let _url = url.split('?')
      // let _url1 = _url[0].split('/')   
      // a.download = _url1[3]
      a.href = url
      a.target = "_blank"
      $("body").append(a)
      a.click()
      $(a).remove()
    },

  }

}
</script>